import React, {useEffect, useState} from 'react';
import {Container, Row, Col} from 'reactstrap';
import '../debtPayment.scss';
import gaParams from '../../../../utilities/analytics/constants';
import {gaEvent} from '../../../../utilities/analytics/tracking';
import DeniedMessageBox from '../../../Shared/DeniedMessageBox/DeniedMessageBox';
import { CSSTransition } from 'react-transition-group'

const DeniedMessage = (props) => {
  useEffect(() => {
    gaEvent(
      gaParams.DEBT_PAYMENT_SHOW_PERMDENIED.category,
      gaParams.DEBT_PAYMENT_SHOW_PERMDENIED.eventType,
      gaParams.DEBT_PAYMENT_SHOW_PERMDENIED.eventParams
    );
  }, []);

  const gtagEvent = () => {
    gaEvent(
      gaParams.DEBT_PAYMENT_CLICK_PERMDENIED.category,
      gaParams.DEBT_PAYMENT_CLICK_PERMDENIED.eventType,
      gaParams.DEBT_PAYMENT_CLICK_PERMDENIED.eventParams
    );
  };

  return (

      <Container className='debtpayment-deniedmessagebox'>
        <Row className='justify-content-md-center'>
          <Col lg='4' className='p-0'>
            <DeniedMessageBox
              text={props.messageText}
              subText={props.subMessageText}
              asBtn={props.isMobile ? true : false}
              onclick={gtagEvent}
            />
          </Col>
        </Row>
      </Container>

  );
};

export default DeniedMessage;
